/**
 * formatPKR — the single place a PKR amount becomes display text.
 *
 * Every call site used to interpolate the ₨ glyph inline (`` `₨${n}` ``), which
 * left currency formatting defined independently in eleven places — a plain
 * singleton violation, and the reason the Billing tab's tier table could ever
 * render two different glyph shapes for the same character in the same table.
 * One function, imported everywhere, makes that impossible again.
 */
export function formatPKR(n: number, digits = 0): string {
  return `₨${n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
}

/**
 * formatPKRCompact — a large PKR amount at the size an operator reads it: `₨281M`, `₨1.2B`,
 * `₨45K`. For headline and ranking figures, where the last digits are noise; use `formatPKR`
 * where the exact amount matters (a bill).
 */
export function formatPKRCompact(n: number): string {
  return `₨${n.toLocaleString(undefined, { notation: "compact", maximumFractionDigits: 1 })}`;
}
